export default __webpack_public_path__ + "static/media/Slider_1500_Web.f714117c.png";